<div class="col agency-card-container">
  <div class="card text-center bg-white text-black h-100">
    <div class="card-body">
      <div class="mb-4">
        <svg-icon class="custom-icon" [src]="icon"></svg-icon>
      </div>
      <h2 class="card-title mb-4 text-black ">{{desc}}</h2>
      <app-button (click)="goTo()" [text]="btnText"  [stroked]="true"></app-button>
    </div>
  </div>
</div>
